import client from './client';
import { trackCheckoutStarted } from '../utils/analytics';

/**
 * Create a Stripe Checkout session for subscription purchase
 */
export const createCheckoutSession = async (priceTier) => {
  trackCheckoutStarted(priceTier);
  const returnUrl = window.location.origin;
  const response = await client.post('/api/stripe/create-checkout-session', {
    price_tier: priceTier,
    return_url: returnUrl
  });
  return response.data;
};

/**
 * Cancel the user's subscription (sets cancel_at_period_end=True)
 * Subscription remains active until end of billing period
 */
export const cancelSubscription = async () => {
  const response = await client.post('/api/stripe/cancel-subscription');
  return response.data;
};

/**
 * Reactivate a cancelled subscription (removes cancel_at_period_end)
 */
export const reactivateSubscription = async () => {
  const response = await client.post('/api/stripe/reactivate-subscription');
  return response.data;
};

/**
 * Create a Stripe Customer Portal session for payment method updates only
 */
export const updatePaymentMethod = async () => {
  const returnUrl = `${window.location.origin}${process.env.PUBLIC_URL || ''}/dashboard?payment_updated=success`;
  const response = await client.post('/api/stripe/update-payment-method', {
    return_url: returnUrl
  });
  return response.data;
};
